import { render, staticRenderFns } from "./DataListEquipements.vue?vue&type=template&id=2d126932&"
import script from "./DataListEquipements.vue?vue&type=script&lang=js&"
export * from "./DataListEquipements.vue?vue&type=script&lang=js&"
import style0 from "./DataListEquipements.vue?vue&type=style&index=0&id=2d126932&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports